var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('notifications',{attrs:{"position":"top center","width":"100%"}}),_c('div',{ref:"paymentwidget",staticClass:"payment-widget",attrs:{"id":"payment-widget"},on:{"click":_vm.interaction}},[_c('router-view',{staticClass:"app-content"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }